import { useVideoPlatform } from '../hooks/useVideoPlatform';
import { QualityMode, VideoPlatform, useStoredAudioVideoSettings } from '../video-sdk';
import { UnstableInternetToast, UnstableInternetToastProps } from './UnstableInternetToast';

export function UnstableInternetToastWrapper(props: Omit<UnstableInternetToastProps, 'isPerformanceMode'>) {
  const isPerformanceMode =
    useStoredAudioVideoSettings().storedAudioVideoSettings?.videoQualityMode === QualityMode.Low;
  const videoPlatformIsZoom = useVideoPlatform() === VideoPlatform.Zoom;
  const areVideoQualitySettingsAvailable = !videoPlatformIsZoom;

  return (
    <UnstableInternetToast
      {...props}
      areVideoQualitySettingsAvailable={areVideoQualitySettingsAvailable}
      isPerformanceMode={isPerformanceMode}
    />
  );
}
